import React from 'react'
import { CardHeader, Typography, Box } from '@mui/material'
import HeaderBgImage from './header-bg.png'
import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'
import { useAppState } from 'appContext'
import { isNilOrEmpty } from 'packages/core'
import { Tooltip } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'
import config from 'config'

const useCardContentStyles = makeStyles({
    headingBG: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 0,
        right: 0,
        top: 0,
        borderRadius: '8px',
    },
    Oval: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        height: '88px',
        width: '88px',
        zIndex: 1,
        left: 5,
        top: -4,
        boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.05)',
        border: 'solid 1px rgba(0, 0, 0, 0.15)',
        borderRadius: '50%',
        backgroundColor: '#fff',
    },
    headingContentBox: (props) => ({
        position: 'relative',
        padding: '20px',
        paddingLeft: props.mobile ? '20px' : '26px',
        paddingRight: '10px',
        minHeight: '80px',
        width: '100%',
    }),
    heading: {
        width: '100%',
        height: '100%',
        zIndex: 1,
        overflow: 'hidden',
        maxWidth: '690px',
    },
    image: {
        height: '100%',
        width: '100%',
        borderRadius: '50%',
    },
})

const MyCardHeader = withStyles({
    root: {
        padding: 0,
        width: '100%',
        overflow: 'hidden',
        borderTopRightRadius: '8px',
        borderTopLeftRadius: '8px',
    },
    content: {
        width: '100%',
    },
    title: {
        fontSize: '24px',
        fontWeight: '600',
    },
})(CardHeader)

const tooltipStyles = {
    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
    padding: '8px',
    maxWidth: '500px',
}

const ItemHeader = ({ title, url }) => {
    const [{ appConfig }] = useAppState()
    const contentClasses = useCardContentStyles()
    const maxCharacters = title && title.length > 0 && url ? 17 : 28
    const { t } = useTranslation()
    let titleText = isNilOrEmpty(title) ? '' : title
    titleText =
        titleText.length > maxCharacters
            ? `${titleText.substring(0, maxCharacters)}...`
            : titleText

    const titleJsx = (
        <Typography
            className={contentClasses.heading}
            style={{
                fontWeight: 'bold',
                fontSize: '18px',
                lineHeight: '38px',
                color: '#fff',
                display: 'block',
                wordBreak: 'break-word',
                wordWrap: 'break-word',
                marginLeft: url ? '80px' : '0px',
            }}
        >
            {titleText}
        </Typography>
    )

    let wrappedTitle

    if (titleText.length > maxCharacters) {
        wrappedTitle = (
            <Tooltip
                title={title}
                color="#5D6870"
                fontColor="#ffffff"
                enterDelay={500}
                enterNextDelay={500}
                disableInteractive={false}
                tooltipStyles={tooltipStyles}
            >
                {titleJsx}
            </Tooltip>
        )
    } else {
        wrappedTitle = titleJsx
    }

    return (
        <MyCardHeader
            className={contentClasses.cardHeader}
            title={
                <>
                    {url && (
                        <Box className={contentClasses.Oval}>
                            <img
                                className={contentClasses.image}
                                src={url}
                                alt={t('ResourceImage')}
                            />
                        </Box>
                    )}
                    <Box
                        className={contentClasses.headingContentBox}
                        display="flex"
                        alignItems="center"
                        overflow="hidden"
                        style={{
                            background: appConfig.style.colors.primary.gradient,
                        }}
                    >
                        {wrappedTitle}

                        <img
                            className={contentClasses.headingBG}
                            src={`${config.APP_SUBPATH}${HeaderBgImage}`}
                            alt={t('background')}
                        />
                    </Box>
                </>
            }
        />
    )
}

export default ItemHeader
